import { ellipseIfOver } from './utils';
import { getMaxHashtags } from './keyword_utils';
import type { SocialShareParams, AliasDefinition } from './../imports';
export const getPreciseParam = (
  paramDef: AliasDefinition,
  inputParams: Record<string, string | null>
): [string | null, Record<string, string | null>] => {
  const alias = paramDef.alias;
  const inputParamsCopy = { ...inputParams };
  for (const key of Object.keys(inputParamsCopy)) {
    if (alias.includes(key)) {
      const value = inputParamsCopy[key];
      delete inputParamsCopy[key];
      return [value, inputParamsCopy];
    }
  }
  return [null, inputParamsCopy];
};

// Budget order matters: the url and via are fixed costs, the text (page
// description + summary) takes what it needs next, and hashtags pad whatever
// space is left toward the platform's ideal share length.
export const conformParamsToCharLimits = (
  inputParams: Record<string, string | null>,
  characters: SocialShareParams['characters'],
  hashSymbol: boolean
): Record<string, string | null> => {
  const maxChars = characters.limit || Number.MAX_SAFE_INTEGER;
  let charsAvailable = maxChars;
  const outputParams = { ...inputParams };

  if (outputParams.url) {
    // Platforms like X wrap links (t.co), so the counted cost is url_len, not
    // the literal length. +1 for the newline that joins it into the post.
    charsAvailable -= (characters.url_len || outputParams.url.length) + 1;
  }

  if (outputParams.via) {
    // Store the bare handle: intent params (x via=) want it without '@';
    // createOutputText re-adds the '@' when via is folded into the text.
    outputParams.via = outputParams.via.replace(/^@+/, '');
    charsAvailable -= outputParams.via.length + 2; // '@' + newline
  }

  if (outputParams.text) {
    outputParams.text = ellipseIfOver(outputParams.text, Math.max(charsAvailable, 0));
    charsAvailable -= outputParams.text.length + 1;
  }

  if (outputParams.hashtags) {
    // Hashtags fill the remaining space, capped near the platform's optimal
    // size so huge-limit platforms (facebook, whatsapp) don't get every tag.
    const fillCap = Math.min(
      Math.max(charsAvailable, 0),
      Math.max(characters.optimal ?? 100, 60)
    );
    outputParams.hashtags = getMaxHashtags(outputParams.hashtags, fillCap, null, hashSymbol) || null;
  }

  return outputParams;
};
